var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 26,
    viewBox: "0 0 133 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.9593 21.1415V4.61914H81.2221V8.45447H75.236V21.1415H70.9531H70.9593Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1732 21.1415V14.6706H87.8141V21.1415H83.5312V4.61914H87.8141V10.7855H94.1732V4.61914H98.4561V21.1415H94.1732Z",
    fill: "#282828"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.295 21.1415V8.45447H118.297V4.61914H132.6V8.45447H127.578V21.1415H123.295Z",
    fill: "#282828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.971 21.1415V11.7241L105.159 21.1415H101.578V4.61914H105.861V13.9371L112.562 4.61914H116.261V21.1415H111.978H111.971Z",
    fill: "#282828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3675 21.1415V11.3201L42.0908 16.5105L37.8141 11.3201V21.1415H33.5312V4.61914H37.7582L42.0908 10.3007L46.4234 4.61914H50.6504V21.1415H46.3675Z",
    fill: "#282828"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7425 15.3295H62.7208L60.7316 10.1515L58.7425 15.3295ZM64.9523 21.1415L64.0572 18.8291H57.3998L56.5047 21.1415H52.2031L58.786 4.61914H62.7456L69.3285 21.1415H64.9523Z",
    fill: "#282828"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 7.96715C0.40625 5.97178 1.18948 4.05722 2.58189 2.64617C3.96808 1.23511 5.85155 0.439453 7.81584 0.439453H24.9226V4.26857H7.82206C6.85856 4.26857 5.93236 4.6664 5.24859 5.35639C4.56482 6.05259 4.17942 6.99122 4.17321 7.96715L4.14834 14.3884C4.06753 15.2089 3.72565 15.9859 3.17241 16.5889C2.61297 17.1918 1.87947 17.5897 1.07759 17.7264L0.40625 17.8321V7.96715Z",
    fill: "#282828"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.40625 25.293V21.4639H17.513C18.4765 21.4639 19.4027 21.0661 20.0864 20.3761C20.7702 19.6799 21.1556 18.7413 21.1618 17.7653V11.6673C21.1618 10.7847 21.4788 9.92684 22.0445 9.2555C22.6102 8.58416 23.3934 8.14282 24.2512 7.99985L24.9226 7.90039V17.7591C24.9226 19.7545 24.1393 21.6691 22.7469 23.0801C21.3607 24.4912 19.4772 25.2868 17.513 25.293H0.40625Z",
    fill: "#282828"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9314 17.8496V12.9016L12.6999 15.6056L10.4683 12.9016V17.8496H7.51562V8.11523H10.3129L12.6999 11.2481L15.0868 8.11523H17.8841V17.8496H14.9314Z",
    fill: "#282828"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnit);
export default __webpack_public_path__ + "static/media/Magnit.cd9ec4f80bc73adc7cc1dd10956afca3.svg";
export { ForwardRef as ReactComponent };